import "../../config.js";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import AppMainMyCard from './AppMainMyCard.js';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import ContactMailIcon from '@mui/icons-material/ContactMail';

const AppMainMy = (props) => {

  const handleArrowforwardClick = (url) => {
    var tmp_url = url;
    if (tmp_url === undefined || tmp_url === null || tmp_url.length < 1) {
      window.location.href = global.constants.const_url;
    } else {
      window.location.href = tmp_url
    }
  }

  return (
    <div style={{ flexGrow: 1 }}>
      <Grid container direction="row" spacing={0} >
        <Grid item xs={12}>
          <AppMainMyCard />
          <Divider />
        </Grid>

        <Grid item xs={12} >
          <List>
            <ListItem key={'k-qrcode'} button onClick={() => { handleArrowforwardClick(global.constants.const_url + "/qrcode") }} >
              <ListItemIcon>
                <FingerprintIcon color="primary" />
              </ListItemIcon>
              <ListItemText id="switch-list-label-bluetooth" primary={global.constants.const_home_qrcode_name} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="arrowforward" onClick={() => { handleArrowforwardClick(global.constants.const_url + "/qrcode") }} >
                  <ArrowForwardIosIcon color="primary" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider variant="inset" component="" />
          </List>
        </Grid>

        <Grid item xs={12} >
          <List >
            <ListItem key={'k-stmt'} button onClick={() => { handleArrowforwardClick(global.constants.const_home_url + "/user/stmt") }}>
              <ListItemIcon>
                <NotificationsNoneIcon color="primary" />
              </ListItemIcon>
              <ListItemText id="switch-list-label-bluetooth" primary={global.constants.const_home_statement_name} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="arrowforward" onClick={() => { handleArrowforwardClick(global.constants.const_home_url + "/user/stmt") }} >
                  <ArrowForwardIosIcon color="primary" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Grid>

        <Grid item xs={12} >
          <List >
            <ListItem key={'k-quest'} button onClick={() => { handleArrowforwardClick(global.constants.const_home_url + "/user/question") }}>
              <ListItemIcon>
                <ContactMailIcon color="primary" />
              </ListItemIcon>
              <ListItemText id="switch-list-label-bluetooth" primary={global.constants.const_question} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="arrowforward" onClick={() => { handleArrowforwardClick(global.constants.const_home_url + "/user/question") }} >
                  <ArrowForwardIosIcon color="primary" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Grid>

      </Grid>
    </div>
  );

}
export default () => <AppMainMy />;
